module.exports = __webpack_public_path__ + "img/grey-marker.4f8545ed.svg";